const servers = {
	"tutores-dotia.dev.doubledot.es" : "https://sandboxbackcliente1.dotia.es",
	"tutores-uax.dev.doubledot.es" : "https://sandbox-uax.dotia.es",
	"tutores-comillas.dev.doubledot.es" : "https://sandbox-comillas.dotia.es",
	"tutores-uc3m.dev.doubledot.es" : "https://sandbox-uc3m.dotia.es",
	"tutores-uc3m-dev.dotia.es" : "https://sandbox-uc3m.dotia.es",
	"tutorpracticas.uc3m.es" : "https://gestionoye.uc3m.es",
	"tutores-uib.dev.doubledot.es" : "https://sandbox-uib.dotia.es",
	"tutores-uva.dev.doubledot.es" : "https://sandbox-uva.dotia.es",
	"localhost:8080": "https://sandbox-uib.dotia.es",
	"traducciones-tutores-uib.dev.doubledot.es" : "https://sandbox-uib.dotia.es",
	"localhost:8081": "https://sandbox-uib.dotia.es",
	"demo-loca-front.dev.doubledot.es" : "https://sandboxbackcliente1.dotia.es",
	"----PRODUCCION----" : "----PRODUCCION----",
	"tutores.empleo.uax.es" : "https://backoffice.empleo.uax.es",
	"tutor.uvaempleo.com" : "https://backoffice.uvaempleo.com",
	"doiptutors.fueib.org" : "https://doipgestio.fueib.org",

}

export default servers;


// WEBPACK FOOTER //
// ./src/servers/index.js